var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "certo",
  transform: "translate(0 0.262)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ret\\xE2ngulo_23",
  "data-name": "Ret\\xE2ngulo 23",
  transform: "translate(0 -0.262)",
  fill: "none",
  stroke: "silver",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 54,
  rx: 7,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 52,
  height: 52,
  rx: 6,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_23",
  "data-name": "Grupo 23",
  transform: "translate(15.804 17.35)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Linha_39",
  "data-name": "Linha 39",
  x2: 9.773,
  y2: 8.796,
  transform: "translate(0 13.682)",
  fill: "none",
  stroke: "#0fb41a",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_40",
  "data-name": "Linha 40",
  x1: 15.637,
  y2: 22.478,
  transform: "translate(9.773)",
  fill: "none",
  stroke: "#0fb41a",
  strokeLinecap: "round",
  strokeWidth: 3
})));
function SvgCerto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerto);
export default __webpack_public_path__ + "static/media/certo.66f6178f2f22980d15c4c92072bf528f.svg";
export { ForwardRef as ReactComponent };